import { RtbCampaignPlanType } from 'core/rtbCampaign/RtbCampaign';
import { AbstractOutdoorStoreFormModel } from './OutdoorLimitationCampaignFormModel';
import {
  LimitationConfig,
  RtbCampaignBasicFormModelConstructorParams
} from './RtbCampaignBasicFormModel';
import { L1ObjectObjective } from 'core/l1Object/L1Object';
import { L2ObjectOptimizationGoal } from 'core/l2Object/L2Object';
import { OPERATE } from 'enum/Operate';
import { ChannelGroupSetting } from 'core/channelGroup/ChannelGroupSettings';

export abstract class AbstractLineMessageFormModel extends AbstractOutdoorStoreFormModel {
  get onlyDaypartingOptimize(): boolean {
    return true;
  }

  get onlySupportAcceleratedDeliverType(): boolean {
    return true;
  }

  override get onlyBidCap(): boolean {
    return true;
  }

  get campaignAdType() {
    return this.adTypeSetting?.name || 'LINE_MESSAGE';
  }

  override get limitationConfig(): LimitationConfig {
    return {
      defaultLimitationToShow: {
        name: 'customOutdoorDevice',
        operate: OPERATE.INCLUDE
      },
      supportAgeGenderLimitation: false,
      supportAudienceEstimation: false,
      requireIncludeLimitation: false,
      operationSet: {
        need: [OPERATE.INCLUDE]
      }
    };
  }

  override getRtbOptionsMap() {
    const optionsMap = {
      [L1ObjectObjective.AWARENESS]: {
        [RtbCampaignPlanType.FBCPM]: [L2ObjectOptimizationGoal.BCPM]
      },
      [L1ObjectObjective.TRAFFIC]: {},
      [L1ObjectObjective.SALES]: {},
      [L1ObjectObjective.UNSPECIFIED]: {
        [RtbCampaignPlanType.FBCPM]: [L2ObjectOptimizationGoal.BCPM]
      }
    };
    return this.filterOptionsMapByPricingMode(
      optionsMap,
      this.channelGroupSetting.config.id
    );
  }

  override get canUseDailyBudget(): boolean {
    return false;
  }
}

export class EditLineMessageFormModel extends AbstractLineMessageFormModel {
  constructor(
    channelGroupSetting: ChannelGroupSetting,
    ...args: RtbCampaignBasicFormModelConstructorParams
  ) {
    super(channelGroupSetting, 'edit', ...args);
  }
  get canEditBudgetPlan(): boolean {
    return false;
  }
  get canEditPriceModel(): boolean {
    return false;
  }

  canEditOptimize(): boolean {
    return false;
  }
}

export class CreateLineMessageFormModel extends AbstractLineMessageFormModel {
  constructor(
    channelGroupSetting: ChannelGroupSetting,
    ...args: RtbCampaignBasicFormModelConstructorParams
  ) {
    super(channelGroupSetting, 'create', ...args);
  }
  get canEditBudgetPlan(): boolean {
    return true;
  }
  get canEditPriceModel(): boolean {
    return true;
  }
}
